import { useMemo, useState, memo } from 'react';
import { Tabs } from 'antd';
import './styles.scss';
import AllTabData from './TabData.tsx/TabData';
import { useGetContactGroupQuery } from '../importantContactsSlice';
import TabContextProvider from './Context/TabContext';

interface ModalContentProps {
  handleTabChange?: (str: string) => void;
}

function ModalContent({ handleTabChange }: ModalContentProps) {
  const [tab, setTab] = useState('BDC');
  const { data: ContactGroupData } = useGetContactGroupQuery();

  const items = useMemo(() => {
    return ContactGroupData?.results.map((cgd) => ({
      key: cgd.name,
      label: cgd.name,
      children: <AllTabData />,
    }));
  }, [ContactGroupData]);

  const onChange = (key: string) => {
    handleTabChange?.(key);
    setTab(key);
  };

  return (
    <div className="modal-tabs border-b-2 border-b-gray-100">
      <TabContextProvider value={tab}>
        <Tabs
          // activeKey="Report Incidents"
          items={items}
          onChange={onChange}
          size="large"
          className="important-contact-tabs"
        />
      </TabContextProvider>
    </div>
  );
}

export default memo(ModalContent);
